import React from 'react';
import { useNavigate } from 'react-router-dom';
import './DefinitionPage2.css';

const DefinitionPage = () => {
  const navigate = useNavigate();

  return (
    <div className="definition-overlay">
      <div className="definition-box">
        <button className="close-button" onClick={() => navigate(-1)}>×</button>
        <h2>Key Definitions - View Individual Performance</h2>


        <p className="definition-note">
          <strong>Note:</strong> The "Last data updated" date and time on the dashboard shows when the data was last refreshed. All information is based on data available up to that point.
        </p>

        <table className="definition-table">
          <tbody>
            <tr>
              <th>PID</th>
              <td>Choose the project ID you want to view data for.</td>
            </tr>
            <tr>
              <th>Date Range</th>
              <td>Use this to select a start and end date to view data for a specific period.</td>
            </tr>
            <tr>
              <th>Organization Name</th>
              <td>Choose the Organization name (State), which corresponds to the state associated with the selected PID.</td>
            </tr>
            <tr>
              <th>Manager Name</th>
              <td>Select the manager's name to view data specific to that user.</td>
            </tr>
            <tr>
              <th>Total Applications in Open_DI</th>
              <td>
                This shows the total count of schemes that are Opened as of yesterday. If you apply a date filter, it will display the count of schemes opened within your selected date range.
              </td>
            </tr>
            <tr>
              <th>Total Applications in DS_DI</th>
              <td>
                This shows the total count of schemes in "DS" (Document Submitted). If you apply a date filter, it will display the count of DS schemes within your selected date range.
                <br /><strong>Document Submitted:</strong> Status when the application's proof of submission is uploaded to the case.
              </td>
            </tr>
            <tr>
              <th>Total Applications in BR_DI</th>
              <td>
                This shows the total count of schemes in "BR" (Benefit Received) status. If you apply a date filter, it will display the count of BR schemes within your selected date range.
                <br /><strong>Benefit Received:</strong> Status when the application's proof of benefit is uploaded to the case on the app.
              </td>
            </tr>
            <tr>
              <th>Total Applications in Open_DFL</th>
              <td>
                This shows the total count of DFL cases (including both <strong>Short Training</strong> and <strong>Long Training</strong>) that are opened as of yesterday. If you apply a date filter, it will display the count of DFL cases opened within your selected date range.
              </td>
            </tr>
            <tr>
              <th>Total Applications in DS_DFL</th>
              <td>
                This shows the total count of DFL cases (including both Short Training and Long Training) in "DS" (Document Submitted) status. If you apply a date filter, it will display the count of DS schemes within your selected date range.
                <br /><strong>Document Submitted:</strong> Status when the proof of submission is uploaded to the case.
              </td>
            </tr>
            <tr>
              <th>Total Applications in BR_DFL</th>
              <td>
                This shows the total count of DFL cases (including both Short Training and Long Training) in "BR" (Benefit Received) status. If you apply a date filter, it will display the count of BR DFL cases within your selected date range.
                <br /><strong>Benefit Received:</strong> Status when the proof of benefit is uploaded to the DFL case on the app.
              </td>
            </tr>
            <tr>
              <th>Total Applications in Open_YC</th>
              <td>
                This shows the total count of Yojana cards (including <strong>Debit, Loyalty, Prepaid</strong>) that are opened as of yesterday. If you apply a date filter, it will display the count of Yojana cards opened within your selected date range.
              </td>
            </tr>
            <tr>
              <th>Total Applications in DS_YC</th>
              <td>
                This shows the total count of YC (including <strong>Debit, Loyalty, Prepaid</strong>) in "DS" (Document Submitted) status. If you apply a date filter, it will display the count of DS schemes within your selected date range.
                <br /><strong>Document Submitted:</strong> Status when the proof of submission is uploaded to the case.
              </td>
            </tr>
            <tr>
              <th>Total Applications in BR_YC</th>
              <td>
                This shows the total count of YC (including <strong>Debit, Loyalty, Prepaid</strong>) in "BR" (Benefit Received) status. If you apply a date filter, it will display the count of BR YC within your selected date range.
                <br /><strong>Benefit Received:</strong> Status when the proof of benefit is uploaded to the YC case on the app.
              </td>
            </tr>
            <tr>
              <th>Work done in total projects</th>
              <td>
                This shows the total count of unique projects where applications have happened. If you apply date filters, the data displayed will be specific to your selection.
              </td>
            </tr>
            <tr>
              <th>Work done in total Organization</th>
              <td>
                This shows the total count of Unique Orgs where applications have happened. If you apply date filters, the data displayed will be specific to your choices.
              </td>
            </tr>
            <tr>
              <th>Monthly work Done</th>
              <td>
                This chart displays the total case count for DI, DFL, and YC, month by month. You can use the tabs to switch views and see the application counts for "Open", "DS", or "BR" statuses.
              </td>
            </tr>
            <tr>
              <th>Weekly Applications Data</th>
              <td>
                This chart displays the total case count for DI, DFL, and YC, week on week. You can use the tabs to switch views and see the application counts for "Open", "DS", or "BR" statuses.
              </td>
            </tr>
            <tr>
              <th>Project Org wise data</th>
              <td>
                This chart shows you application counts grouped by Project and Organization.
              </td>
            </tr>
            <tr>
              <th>Service Type</th>
              <td>
                This pie chart shows service type wise counts, i.e., the total number of applications in DI, DFL, and YC.
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default DefinitionPage;
